import guardianConsent from '@/router/routes/document/guardianConsent'
import coordinatorQuestionnaire from '@/router/routes/document/coordinatorQuestionnaire'
import beginningOfOurStory from '@/router/routes/document/beginningOfOurStory'
import summaryOfOurStory from '@/router/routes/document/summaryOfOurStory'
import dreamDrawing from '@/router/routes/document/dreamDrawing'

const Document = () => import('@/views/ApDocument.vue')
export default {
  path: '/dokument/:childEditionId',
  component: Document,
  props: true,
  children: [
    guardianConsent,
    coordinatorQuestionnaire,
    beginningOfOurStory,
    summaryOfOurStory,
    dreamDrawing
  ]
}
